import { IGameIdentityDTO } from "motw_core/DTOs/IGameIdentityDTO";
import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import ChevronPanel from "source/app/presentation/Shared/ChevronPanel/ChevronPanel";
import { FormSelect } from "source/app/presentation/Shared/Form/Select/FormSelect";
import { StyleClass } from "../../../../../Shared/Styles/CSS";
import { AddGoalToGameIdentityIcon } from "./AddGoal/AddGoalToGameIdentityIcon";

export function GoalNamesSelector({
    identity,
    allGoals,
    goalNamesLoggedToday,
}: {
    identity: IGameIdentityDTO;
    allGoals: IGoal[];
    goalNamesLoggedToday: string[];
}) {
    const [selectedGoalName, setSelectedGoalName] = React.useState("");

    const suggestions = allGoals
        .filter((goal) => !goal.isarchived)
        .map((goal) => goal.name)
        .sort();

    return (
        <ChevronPanel
            id="addGoalIdentityLinkPanel"
            label="add link to goal"
            dynamicOpacity={false}
        >
            <div>
                <FormSelect
                    label="Add goal"
                    id="goalNamesSelector"
                    maxWidth="105px"
                    onChange={(event) =>
                        setSelectedGoalName(event.target.value)
                    }
                    value={selectedGoalName}
                    suggestions={suggestions}
                    classes={StyleClass(`forceGoalNamesSelectorClickability`, {
                        position: `relative`,
                    })}
                />
                <AddGoalToGameIdentityIcon
                    identity={identity}
                    goals={allGoals}
                    selectedGoalName={selectedGoalName}
                    goalNamesLoggedToday={goalNamesLoggedToday}
                />
            </div>
        </ChevronPanel>
    );
}
